module.exports = __webpack_public_path__ + "static/media/photography.0fade6e3.jpg";